import {Node} from '@tiptap/core'
import {VueNodeViewRenderer, mergeAttributes} from "@tiptap/vue-3"
import View from "./View.vue"

export default Node.create({
  name: 'Html',

  group: 'block',

  atomic: true,

  draggable: true,

  addAttributes() {
    return {
      html: {
        default: '',
      },
    }
  },

  parseHTML() {
    return [
      {
        tag: 'tt-html',
      },
    ]
  },

  renderHTML({HTMLAttributes}) {
    return ['tt-html', mergeAttributes(HTMLAttributes)]
  },

  addNodeView() {
    return VueNodeViewRenderer(View)
  }
})
